import { render, staticRenderFns } from "./project.component.vue?vue&type=template&id=165cea6f&scoped=true&"
import script from "./project.component.vue?vue&type=script&lang=js&"
export * from "./project.component.vue?vue&type=script&lang=js&"
import style0 from "./project.component.vue?vue&type=style&index=0&id=165cea6f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165cea6f",
  null
  
)

export default component.exports